import * as ramda from 'ramda';

import UIErrorMessage from '$shared/constants/UIErrorMessage';
import { UIError } from '$provider/models/error/UIError';

export class NpiValidator {
  static validate(npiNumber: string): void {
    if (!npiNumber) return;

    if (isNaN(Number(npiNumber)) || !ramda.is(Number, Number(npiNumber)))
      throw new UIError(UIErrorMessage.NpiShouldBeNumber);

    if (npiNumber.length !== 10) throw new UIError(UIErrorMessage.InvalidNpi);

    const firstDigit = Number(npiNumber[0]);
    if (firstDigit != 1 && firstDigit != 2) throw new UIError(UIErrorMessage.InvalidNpi);

    //Luhn Formula for Modulus 10 'double-add-double'
    let sum = 0;
    for (let index = npiNumber.length - 2; index >= 0; index--) {
      let currentDigit = parseInt(npiNumber[index]);
      // Double the value of alternate digits, (from rightmost 2st digit)
      if (index % 2 === 0) {
        currentDigit *= 2;
      }

      sum += parseInt((currentDigit / 10).toString());
      sum += currentDigit % 10;
    }

    //Add constant 24, to account for the 80840 prefix, '80' indicates health applications and '840' indicates the United States.(i.e) 8 0 8 (4*2) 0 = 24
    sum += 24;
    //Subtract from next higher number ending in zero
    const checkDigit = Math.ceil(sum / 10.0) * 10 - sum;
    const isValid = checkDigit === Number(npiNumber[9]);
    if (isValid) return;

    throw new UIError(UIErrorMessage.InvalidNpi);
  }
}
